<script lang="tsx" setup>
import { inject, onUnmounted, ref, watch, useSlots, h, render } from "vue"
import { v4 } from "uuid"
import type { Point, Size, Icon, Label, SymbolIcon } from "@p-v/packages/Map/map"

const slots = useSlots()

const domId = ref<string | undefined>(undefined)

interface ComponentProps {
  position: Point //	标注的位置
  dragging?: boolean //	是否可拖拽，默认为false
  size?: number //	标注的大小
  color?: string //	标注的颜色
  zIndex?: number //	标注的z-index值
}

const props = withDefaults(defineProps<ComponentProps>(), {
  position: () => ({ lng: 116.404, lat: 39.915 }),
  dragging: () => false,
  size: () => 30,
  color: () => "#409EFF",
  zIndex: () => 0,
})

const style = ref({
  display: "flex",
  color: props.color,
  zIndex: props.zIndex,
  ["--size"]: `${props.size}px`,
})

watch(
  () => props.zIndex,
  value => {
    style.value.zIndex = value
    overlay.value?.draw()
  },
)

watch(
  () => props.color,
  value => {
    style.value.color = value
    overlay.value?.draw()
  },
)

watch(
  () => props.position,
  value => {
    overlay.value?.updatePosition(value)
  },
)

const bmap = inject("bmap") as any

const overlay = ref<any>(undefined)

const renderFn = () => {
  if (!domId.value) domId.value = v4()
  class CustomerOverlay extends window.BMapGL.Overlay {
    constructor(point) {
      super()
      this._point = point
    }

    initialize(map) {
      this._map = map
      this._el = document.createElement("div")
      this._el.id = domId.value
      this._el.className = "custom-marker"
      this._el.style.position = "absolute"
      render(
        h(() => slots.default?.()),
        this._el,
      )
      // 将 canvas 添加到地图的 labelPane（或其它适合的 pane）中
      map.getPanes().labelPane.appendChild(this._el)
      return this._el
    }

    updatePosition(point) {
      this._point = point
      this.draw()
    }

    draw() {
      // 当地图尺寸变化时更新 canvas 尺寸
      const position = this._map.pointToOverlayPixel(this._point)
      const styleObj = Object.assign(this._el.style, {
        color: style.value.color,
        display: style.value.display,
        width: style.value["--size"] + "px",
        height: style.value["--size"] + "px",
        justifyContent: "center",
        alignItems: "center",
        "--size": style.value["--size"],
        "--color": style.value.color,
        left: position.x - props.size / 2 + "px",
        top: position.y - props.size / 2 + "px",
        zIndex: style.value.zIndex,
      })

      // 声明一个驼峰转连字符方法
      const camel2Line = s => {
        return s.replace(/([A-Z])/g, "-$1").toLowerCase()
      }

      const styleString = Object.keys(styleObj)
        .filter(key => !/^\d+$/.test(key + ""))
        .filter(key => styleObj[key])
        .map(key => `${camel2Line(key)}:${styleObj[key]}`)
        .join(";")
      this._el.style.cssText = styleString
    }

    destroy() {
      if (this._el) {
        render(null, this._el) // 卸载渲染内容
        this._el.remove()
      }
    }
  }
  console.log("renderFn", overlay.value)
  if (!overlay.value) {
    overlay.value = new CustomerOverlay(props.position)
    bmap.value.addOverlay(overlay.value)
  } else {
    overlay.value._point = props.position
    overlay.value.draw()
  }
}

watch(
  () => bmap.value,
  () => {
    if (!bmap.value) return
    renderFn()
    // unwatchBmap()
    // 动态导入updateScaleFactor, RippleOverlay
  },
  {
    immediate: true,
  },
)

onUnmounted(() => {
  overlay.value?.destroy()
  bmap.value?.removeOverlay(overlay.value)
})
</script>
